import { render } from "./person-certificate.vue?vue&type=template&id=0e1f94df&scoped=true"
import script from "./person-certificate.vue?vue&type=script&lang=js"
export * from "./person-certificate.vue?vue&type=script&lang=js"

import "./person-certificate.vue?vue&type=style&index=0&id=0e1f94df&lang=less&scoped=true"

import exportComponent from "/Users/jixubin/thinkcloud/thinkcloud-merchant-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e1f94df"]])

export default __exports__